export const categoryDetails = [
    {
        id: 1,
        default: require('@/assets/净颜卸妆/1_02.jpg'),
        active: require('@/assets/净颜卸妆/1_02.jpg'),
        describe1: '氨基酸「小气泡」卸妆水',
        describe2: '温和沁润 洁净肌肤',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.45.26a6e061fDiXW0&id=636934452717&rn=516901d64a564bb7b61c2eb0f0905f87&abbucket=17'
    },
    {
        id: 2,
        default: require('@/assets/净颜卸妆/1_03.jpg'),
        active: require('@/assets/净颜卸妆/1_03.jpg'),
        describe1: '净颜卸妆湿巾',
        describe2: '一片温和卸除全脸彩妆',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.26a6e061fDiXW0&id=646855821772&rn=516901d64a564bb7b61c2eb0f0905f87&abbucket=17'
    },
    {
        id: 2,
        default: require('@/assets/净颜卸妆/1_04.jpg'),
        active: require('@/assets/净颜卸妆/1_04.jpg'),
        describe1: '净透卸妆棒',
        describe2: '随时随地 一抹卸浓妆',
        links: 'https://m.tb.cn/h.Um74S1H?tk=EKhbd6PIevI'
    },
]